module.exports = "/assets/js/7e75480e1c36fa71d1550379e70eda2f.svg";